import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BoldSubtitle } from 'components/Text/index';
import AddressTypes from 'constants/addressTypes';
import useCountry from 'hooks/language/useCountry';
import useStyles from '../AgreementStyles';
export default function AgreementAddressInfo({
  addressType,
  addressLine1,
  addressLine2,
  careOfName,
  postalCode,
  postalDistrict,
  countryCode
}) {
  const {
    t
  } = useTranslation();
  const {
    getChosenCountryObjectName
  } = useCountry();
  const {
    agreementAddressTitle,
    listItem,
    addressCol,
    addressInfo
  } = useStyles();
  const getAddressString = addressTypeString => addressTypeString === AddressTypes.SHIPPING ? t('address.shipping_address') : t('address.billing_address');
  return /*#__PURE__*/React.createElement("div", {
    className: listItem
  }, /*#__PURE__*/React.createElement("div", {
    className: agreementAddressTitle
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, getAddressString(addressType))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("div", {
    className: addressCol
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: addressInfo
  }, addressLine1), addressLine2 && /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: addressInfo
  }, addressLine2), careOfName && /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: addressInfo
  }, careOfName), /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: addressInfo
  }, postalCode, " ", postalDistrict), countryCode && /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: addressInfo
  }, getChosenCountryObjectName(countryCode)))));
}